import { __awaiter } from "tslib";
import { LeafElementDestination } from "../destination";
export class NoteSelfReferenceDestination extends LeafElementDestination {
    processElementOpen(_reader) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.subDocument.isFootNote())
                this.data.footNotesImporter.insertRun();
            else
                this.data.endNotesImporter.insertRun();
        });
    }
}
